import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchDiagnosticsData = (payload) => {
  return {
    type: types.FETCH_DATA,
    payload,
  };
};

const setFetching = (flag) => ({
  type: types.FETCHING,
  flag,
});

const setError = (flag) => ({
  type: types.SET_ERROR,
  flag,
});

const setDiagnosticsData = (payload) => ({
  type: types.SET_DIAGNOSTICS_DATA,
  payload,
});

const setSelectedAlert = (payload) => ({
  type: types.SET_SELECTED_ALERT,
  payload,
});

export {
  init,
  fetching,
  fetchDiagnosticsData,
  setFetching,
  setError,
  setDiagnosticsData,
  setSelectedAlert,
};
